var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_364_48418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4433 13.6289C14.763 13.6289 17.454 10.9378 17.454 7.61814C17.454 4.29852 14.763 1.60742 11.4433 1.60742C8.12371 1.60742 5.43262 4.29852 5.43262 7.61814C5.43262 10.9378 8.12371 13.6289 11.4433 13.6289Z",
    stroke: "#6E9191",
    strokeWidth: 2.18571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3063 18.6187C16.9235 17.2649 15.1715 16.3497 13.2705 15.9878C11.3694 15.6259 9.40382 15.8334 7.62025 16.5844C5.83669 17.3353 4.31459 18.5961 3.2449 20.2089C2.1752 21.8215 1.60556 23.7142 1.60743 25.6494",
    stroke: "#6E9191",
    strokeWidth: 2.18571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3793 23.4648H17.6364C16.4293 23.4648 15.4507 24.4435 15.4507 25.6506V32.2077C15.4507 33.4148 16.4293 34.3934 17.6364 34.3934H26.3793C27.5864 34.3934 28.565 33.4148 28.565 32.2077V25.6506C28.565 24.4435 27.5864 23.4648 26.3793 23.4648Z",
    stroke: "#6E9191",
    strokeWidth: 2.18571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9214 23.4653V21.2796C24.9214 20.1203 25.382 19.0084 26.2018 18.1886C27.0216 17.3688 28.1335 16.9082 29.2928 16.9082C30.4521 16.9082 31.5641 17.3688 32.3839 18.1886C33.2036 19.0084 33.6642 20.1203 33.6642 21.2796V23.4653",
    stroke: "#6E9191",
    strokeWidth: 2.18571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0074 29.5167C21.7056 29.5167 21.4609 29.272 21.4609 28.9703C21.4609 28.6683 21.7056 28.4238 22.0074 28.4238",
    stroke: "#6E9191",
    strokeWidth: 2.18571
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0078 29.5167C22.3096 29.5167 22.5542 29.272 22.5542 28.9703C22.5542 28.6683 22.3096 28.4238 22.0078 28.4238",
    stroke: "#6E9191",
    strokeWidth: 2.18571
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_364_48418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.9714,
    height: 34.9714,
    fill: "white",
    transform: "translate(0.51416 0.513672)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/admin-icon.a5d0495680c0507547063b20b1bde832.svg";
export { ForwardRef as ReactComponent };